<template>
	<span>{{ value }}</span>
</template>

<script>
export default {
	name: 'ArgSimple',
	props: {value: [String, Number, Boolean, Array]},
}
</script>
